import {BatchSummary} from 'constants/SampleConstants';
import {Optional} from 'util/Types';
import {PreparedSample} from 'workflows/samples/PreparedSampleGroupConstants';

export default function makeSample(
  {
    batchId,
    batch,
    fileId,
    containerId,
  }: {
    batchId?: Optional<string>;
    batch?: Optional<BatchSummary>;
    fileId?: Optional<string>;
    containerId?: Optional<string>;
  },
  id: string | null,
  name: string,
  url: string | null
): PreparedSample {
  return {
    id: id || null,
    name,
    url,
    batch: batch || null,
    batchId: batchId || null,
    fileId: fileId || null,
    containerId: containerId || null,
  };
}
